import { AppShell as MantineAppShell, Burger, Group, NavLink, Text, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { NavLink as RouterNavLink, Outlet, useNavigate } from 'react-router';
import { signOutEverywhere } from '../lib/supabase';
import type { AdminMe } from '../lib/session';
import { ErrorBoundary } from '../components/ErrorBoundary';

export function AdminAppShell({ me }: { me: AdminMe }) {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();

  return (
    <MantineAppShell
      header={{ height: 56 }}
      navbar={{ width: 220, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding="md"
    >
      <MantineAppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
            <Text fw={600}>Ascera Admin</Text>
          </Group>
          <Group gap="sm">
            <Text size="sm" c="dimmed">
              {me.email}
            </Text>
            <Button
              size="xs"
              variant="subtle"
              title="Also signs you out of the ops MCP and the mobile app on this account."
              onClick={async () => {
                await signOutEverywhere();
                void navigate('/login');
              }}
            >
              Sign out everywhere
            </Button>
          </Group>
        </Group>
      </MantineAppShell.Header>

      <MantineAppShell.Navbar p="xs">
        <NavLink component={RouterNavLink} to="/users" label="Users" />
        <NavLink component={RouterNavLink} to="/feedback" label="Feedback" />
        <NavLink component={RouterNavLink} to="/audit" label="Audit" />
        <NavLink component={RouterNavLink} to="/access-failures" label="Access problems" />
      </MantineAppShell.Navbar>

      <MantineAppShell.Main>
        {/* Route-level: a broken data screen shows its own error here, not a
            blanked-out header/nav/sign-out. */}
        <ErrorBoundary label="Page">
          <Outlet />
        </ErrorBoundary>
      </MantineAppShell.Main>
    </MantineAppShell>
  );
}
